import React from "react";

const Contact = () => (
  <section className="max-w-xl mx-auto py-12 px-4">
    <h1 className="text-3xl font-bold text-center mb-6 text-gray-900 uppercase">Contacto</h1>
    <p className="text-lg text-gray-700 mb-6 text-center">
      ¿Encontraste algún error en una ficha técnica o tienes una sugerencia para mejorar Aromas Datasheet?
    </p>
    <p className="text-gray-700 text-center mb-8">
      ¡Tu aporte es muy valioso! No dudes en escribirnos a&nbsp;
      <a
        href="mailto:esencianomadaperfumes@gmail.com"
        className="text-indigo-700 underline font-semibold hover:text-indigo-900 transition-colors"
      >
        esencianomadaperfumes@gmail.com
      </a>
      &nbsp;para ayudarnos a mantener la base de datos siempre actualizada y útil para toda la comunidad.
    </p>
  </section>
);

export default Contact;
